export const SMART_MODE_STORAGE_KEY = "kagami-aimodelinput-smart-mode";

export const DEFAULT_MODEL_STORAGE_KEY = "kagami-aimodelinput-selected-model";

export const VISUAL_TYPES = [
  "image",
  "video",
  "audio",
  "elements",
  "video_elements",
  "audio_elements",
];

export const SETTING_TYPES = [
  "options",
  "boolean",
  "character",
  "voice_settings",
  "number",
];

export const ELEMENTS_INPUT_TYPE_FOR = {
  image: "elements",
  video: "video_elements",
  audio: "audio_elements",
};

export const ELEMENTS_INPUT_TYPES = new Set(
  Object.values(ELEMENTS_INPUT_TYPE_FOR),
);

export function elementsMediaType(inputType) {
  if (inputType === "elements") return "image";
  if (inputType === "video_elements") return "video";
  if (inputType === "audio_elements") return "audio";
  return inputType;
}
